// マイページ 日付+日時検索

var $ = require("jquery");
import "../../stylesheets/datetime";
// ライブラリをインポート
import flatpickr from "flatpickr";
// 日本語へローカライズ
import { Japanese } from "flatpickr/dist/l10n/ja.js";

$(function () {
  flatpickr("#flatpickr", {
    enableTime: true,
    dateFormat: "Y/m/d H:i",
    defaultHour: 0,
    minuteIncrement: 1,
    // ローカライズ
    locale: Japanese
  });
});
